var React = require("react");
var Radium = require("radium");
var DefaultSign = require("./Sign.jsx");

var divStyle = {
	base: {
		position: 'relative',
		cursor: "pointer",
		display: "inline-block",
		padding: 5
	},

	disabled: {
		opacity: 0.5,
		cursor: "default"
	}
};

var boxStyle = {
	width: 14,
	height: 14,
	display: "inline-block",
	border: "1px solid #666",
	borderRadius: 2,
	position: "relative"
};

var inputStyle = {
	position: "absolute",
	marginTop: 0,
	opacity: 0,
	WebkitAppearance: "none",
	zIndex: 100,
	cursor: "inherit"
};

var labelStyles = {
	base: {
		marginLeft: 5,
		bottom: 2,
		position: "relative",
		MozUserSelect: "none",
		WebkitUserSelect: "none",
		msUserSelect: "none",
		color: '#444444',
		transition: "color 0.2s",
		cursor: "inherit"
	},

	checked: {
		color: '#03a6dc'
	},

	empty: {
		display: "none"
	}
};

var touchAreaStyle = {
	position: 'absolute',
	display: 'block',
	top: -5,
	left: -5,
	right: -5,
	bottom: -5
};

module.exports = Radium(
	React.createClass({
		propTypes: {
			label: React.PropTypes.string,
			onChange: React.PropTypes.func.isRequired,
			checked: React.PropTypes.bool,
			customBoxStyle: React.PropTypes.object,
			Sign: React.PropTypes.func,
			touchAria: React.PropTypes.bool
		},

		getDefaultProps: function() {
			return {
				checked: false
			};
		},

		change: function(evt) {
			var me = this, props = me.props;

			evt.stopPropagation();

			if (props.disabled) {
				return;
			}

			props.onChange(!props.checked, evt);
		},

		render: function() {
			var me = this, props = me.props,
				label = props.label, Sign = props.Sign || DefaultSign,
				touchArea = null;

			if (props.touchAria)
				touchArea = (<span style={touchAreaStyle}></span>);

			return (
				<div>
					<div
						style={[
							divStyle.base,
							props.disabled ? divStyle.disabled : undefined
						]}
						onClick={me.change}
						className="rctCheckboxWrapper">
						{touchArea}
						<input
							type="checkbox"
							style={[
								boxStyle,
								inputStyle
							]}/>
						<span style={[boxStyle, props.customBoxStyle]}>
							<Sign checked={props.checked} className="rctCheckboxSign"/>
						</span>
						<span
							style={[
								labelStyles.base,
								typeof label === "undefined" ? labelStyles.empty : undefined,
								props.checked ? labelStyles.checked : undefined
							]}>
							{label}
						</span>
					</div>
				</div>
			);
		}

	})
);


// WEBPACK FOOTER //
// ./src/components/Checkbox/Checkbox.jsx